import { connect } from 'react-redux';
import Header from './Header';
import { showLoginModal } from '../../redux/modules/login';

const mapDispatchToProps = {
  showLoginModal
};

const mapStateToProps = ({
  system: { siteName, isMobile, isTouchDevice, theme, geocountry, rebrandHeader },
  intl: { locale, currency },
  user: { isUserLogged, preferredLocale },
  content: { header: data, feedback }
}) => ({
  siteName,
  locale,
  isMobile,
  geocountry,
  rebrandHeader,
  preferredLocale,
  isTouchDevice,
  isUserLogged,
  data,
  currency,
  theme,
  feedback
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
